(function(root,factory){const api=factory();if(typeof module==='object'&&module.exports)module.exports=api;else root.QSCalendarFeed=api;})(typeof globalThis!=='undefined'?globalThis:this,function(){
  'use strict';
  const legacy = {
    'class-verny-embroidery-club-beginner-free-class':['embroidery-beginner'],
    'kids-sew-club':['junior-sew'],
    'tlc-teresas-longarm-club':['tlc-longarm','tlc-prostitcher']
  };
  function combine(base,products){
    const migrated=new Set();
    const current=products.map(product=>{
      // A tagged legacy product takes ownership even when its dates are empty.
      // Removing an old date must not resurrect a hard-coded club session.
      const bookings=[...(product.bookings||[])];
      for(const id of legacy[product.productHandle]||[]){
        migrated.add(id);
        const old=base.find(s=>s.id===id);
        const schedule=typeof old?.schedule==='string'?JSON.parse(old.schedule):old?.schedule;
        for(const session of schedule?.sessions||[]){
          const match=(product.variants||[]).filter(v=>session.variantId?String(v.id)===String(session.variantId):session.variantTitle&&v.title===session.variantTitle);
          if(match.length===1)bookings.push({...session,variantId:String(match[0].id)});
        }
      }
      return {...product,bookings};
    });
    return [...base.filter(source=>!migrated.has(source.id)),...current];
  }
  async function load(url,{fetcher=fetch,signal,origin=location.origin}={}){
    const endpoint=new URL(url,origin);
    if(endpoint.origin!==origin)throw new Error('Class feed must use this storefront');
    if(typeof location!=='undefined'){
      const preview=new URLSearchParams(location.search).get('preview_theme_id');
      if(preview)endpoint.searchParams.set('preview_theme_id',preview);
    }
    const sources=[];
    for(let page=1;page<=100;page++){
      endpoint.searchParams.set('page',String(page));
      const response=await fetcher(endpoint.href,{signal,credentials:'same-origin',cache:'no-store'});
      if(!response.ok)throw new Error('Class feed returned HTTP '+response.status);
      const html=await response.text();
      const document=new DOMParser().parseFromString(html,'text/html');
      const script=document.querySelector('[data-qs-product-feed]');
      if(!script)throw new Error('Class feed section missing in this theme');
      const payload=JSON.parse(script.textContent);
      if(![1,2].includes(payload.version)||(payload.feedReady!==true&&payload.collectionReady!==true)||!Array.isArray(payload.sources))throw new Error('Class feed is not available');
      if(payload.page!==page||!Number.isInteger(payload.pages)||payload.pages<0||payload.pages>100)throw new Error('Invalid class feed pagination');
      sources.push(...payload.sources);
      if(page>=payload.pages)return sources;
    }
    throw new Error('Class feed exceeds supported pagination');
  }
  return {load,combine};
});
